import { forwardRef, memo, useImperativeHandle, useRef, useState } from "react";
import React from "react";

import { ReactComponent as FilterIcon } from "assets/icons/filter-3-line.svg";
import { validateFilterValues } from "utils/filter";

import { Paragraph3 } from "ui/typography";

import { FilterPopUp } from "./filter-popup";
import { FilterPopUpContent } from "./filter-popup/FilterPopUpContent";
import { IFilterPopUpRef } from "./filter-popup/types";
import { FilterBtn } from "./styles";
import { IFilterProps, IFilterRef } from "./types";

export const FILTER_POSITION_YAXIS_OFFSET = 10;

export const Filter = memo(
  forwardRef<IFilterRef, IFilterProps>((props, ref) => {
    const {
      options,
      values,
      onChange,
      onApplyFilter,
      isLoading,
      header,
      headerTitle,
      footer,
      filterBtnCss,
      customFilterPopUpCss,
      customFilterBodyCss,
      filterButtonBoundingRect,
      isApplyBtnDisabled,
      handleResetFilter,
    } = props;

    const [popUpPosition, setPopUpPosition] = useState({
      top: 0,
      left: 0,
    });
    const filterBtnRef = useRef<HTMLButtonElement | null>(null);
    const filterPopUpRef = useRef<IFilterPopUpRef>(null);

    const handleToggleFilter = () => {
      if (!filterPopUpRef.current || !filterBtnRef.current) return;

      const rect =
        filterButtonBoundingRect ||
        filterBtnRef.current.getBoundingClientRect();
      setPopUpPosition({
        top: rect.top - FILTER_POSITION_YAXIS_OFFSET,
        left: rect.left,
      });
      filterPopUpRef.current.handleTogglePopup();
    };

    useImperativeHandle(ref, () => ({
      isFilterOpen: filterPopUpRef.current?.isPopUpOpen || false,
      handleToggleFilter,
    }));

    if (!validateFilterValues(options, values)) {
      console.error("Invalid filterValues provided to Filter component!");
      return null;
    }

    return (
      <>
        <FilterBtn
          onClick={handleToggleFilter}
          ref={filterBtnRef}
          css={filterBtnCss}
        >
          <FilterIcon />
          <Paragraph3 lineHeight="20px">Filter</Paragraph3>
        </FilterBtn>
        <FilterPopUp
          ref={filterPopUpRef}
          position={popUpPosition}
          customFilterPopUpCss={customFilterPopUpCss}
        >
          <FilterPopUpContent
            handleApplyFilter={onApplyFilter}
            handleToggleFilter={handleToggleFilter}
            options={options}
            values={values}
            onChange={onChange}
            isLoading={isLoading}
            header={header}
            footer={footer}
            headerTitle={headerTitle}
            customFilterBodyCss={customFilterBodyCss}
            isApplyBtnDisabled={isApplyBtnDisabled}
            handleResetFilter={handleResetFilter}
          />
        </FilterPopUp>
      </>
    );
  })
);
